import type { TripStop } from '../policies/trip-stops.policy';
import type { TripPageData } from '../trips.api';
import { TripMapPanel } from './TripMapPanel';

/** The overview is the map: where the trip has been and whether it is still moving. The header above carries the facts. */
export function TripOverviewTab({ trip, stops, onFreshFix }: { trip: TripPageData; stops: TripStop[]; onFreshFix: () => void }) {
  return <TripMapPanel trip={trip} stops={stops} onFreshFix={onFreshFix} />;
}
